import { put, call, select } from 'redux-saga/effects';
import { apiPreprocessingFundProfilesFundsGet } from '../api/preprocessingFundProfiles';
import { PREPROCESSING_FUND_PROFILES_FUNDS_GET } from '../actions/types';
import { createQadraSaga } from './shared';

export function* preprocessingFundProfilesFundsGet({
  payload: { peerProfileId, interval, numberOfClusters, refresh },
}) {
  if (refresh) {
    interval = yield select((s) => s.preprocessingFundProfiles.interval);
    numberOfClusters = yield select((s) => s.preprocessingFundProfiles.numberOfClusters);
    peerProfileId = yield select((s) => s.preprocessingFundProfiles.peerProfileId);
  }

  const { clusteredFunds } = yield call(apiPreprocessingFundProfilesFundsGet, peerProfileId, {
    interval,
    numberOfClusters,
  });

  const clusteredFundsMap = clusteredFunds.reduce((map, item, i) => {
    return { ...map, [item.id]: { ...item, index: i } };
  }, {});

  yield put({
    type: PREPROCESSING_FUND_PROFILES_FUNDS_GET._SUCCESS,
    payload: {
      interval,
      numberOfClusters,
      peerProfileId,
      clusteredFunds,
      clusteredFundsMap,
    },
  });
}

const watchPreprocessingFundProfilesFundsGet = createQadraSaga(preprocessingFundProfilesFundsGet, {
  action: PREPROCESSING_FUND_PROFILES_FUNDS_GET._REQUEST,
});

export default [watchPreprocessingFundProfilesFundsGet];
